<template>
  <div class="col-12 account-birthday-section global-shadow customer-panel-col" id="bdayCol" v-if="showForm">
    <div class="customer-block-header">
      <div class="row">
        <div class="col-12 col-lg-9">
          <div class="customer-panel-ttl">Birthday</div>
          <span class="birthday-par">
              {{ t('birthday.static.text') }}
            </span>
        </div>
        <div class="col-3 birthday-img-sec">
          <img src="/ui/main/img/birthday-gift-asset.png">
        </div>
        <div class="col-12 customer-birthday-terms mt-2">
          <span>{{ t('birthday.text.terms') }}</span>
        </div>
      </div>
    </div>
      <div id="submitBday">
        <input class="col-12 col-lg-6" type="date" v-model="birthDay">
        <button class="col-12 col-lg-6" v-on:click="formSubmit()" type="button">{{ t('entry.lbl') }}</button>
        <div v-if="showError" class="alert alert-error">{{ error }}</div>
      </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'BirthdayForm',
  props: {
    hasBirthday: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      birthDay: '',
      formPosted: false,
      showError: false,
      error: ''
    }
  },
  computed: {
    showForm () {
      return !this.hasBirthday && !this.formPosted
    }
  },
  methods: {
    formSubmit () {
      if (!this.validateDate()) {
        this.error = this.t('birthday.emptyField')
        this.showError = true
        return
      }

      this.postData()
    },
    validateDate () {
      const regex = /^\d{4}-\d{2}-\d{2}$/
      if (!regex.test(this.birthDay)) {
        return false
      }

      const date = new Date(this.birthDay)
      return !isNaN(date.getTime())
    },
    postData () {
      axios
        .post('/api/customer/addBirthDay', { date: this.birthDay })
        .then((response) => {
          this.formPosted = true
        })
        .catch((error) => {
          if (error.response) {
            this.error = error.response.data.date
            this.showError = true
          }
        })
    }
  }
}
</script>
